import React, { useEffect, useMemo, useState } from "react";
import { getClubs } from "../../../services/clubServices";
import CarteClubsNouvelleAquitaine from "./CarteClubsNouvelleAquitaine";
import ClubListNA from "./ClubListNA";
import HeroImage from "./../../../components/Hero/HeroImage";


const PageCarteClubs = () => {
  const [clubs, setClubs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filtres
  const [q, setQ] = useState("");
  const [dep, setDep] = useState("");
  const [mode, setMode] = useState(
    () => localStorage.getItem("na_clubs_mode") || "map"
  ); // "map" | "list"

  // helper recherche insensible aux accents/majuscules
  const norm = (s = "") =>
    s
      .toString()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .toLowerCase();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await getClubs();
        setClubs(Array.isArray(data) ? data : []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    localStorage.setItem("na_clubs_mode", mode);
  }, [mode]);

  const departements = useMemo(() => {
    const vals = clubs.map((c) => c.departement_club).filter(Boolean);
    return [...new Set(vals)].sort((a, b) =>
      String(a).localeCompare(String(b))
    );
  }, [clubs]);

  const filtered = useMemo(() => {
    const nq = norm(q);
    return clubs.filter((c) => {
      const nameOk = !nq || norm(c?.nom_club || "")?.includes(nq);
      const communeOk = !nq || norm(c?.adresse_club || "")?.includes(nq); // ← recherche dans l'adresse (commune)
      const depOk = !dep || String(c?.departement_club) === String(dep);
      return (nameOk || communeOk) && depOk;
    });
  }, [clubs, q, dep]);

  return (
    <div className="w-full pt-[70px] font-satoshi">
          {/* HERO */}
          <HeroImage
            title="Carte des Clubs de NA"
            subtitle="Tri par département et recherche par nom ou commune"
            imageUrl="/img/cover/cover_calendar_france.jpeg"
          />

      {/* Filtres + mode */}
      <div className="bg-white shadow-lg rounded-xl p-4 mt-4 w-full max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-3 items-stretch lg:items-end">
          <div className="flex-1">
            <label className="text-xs uppercase tracking-wide opacity-70">
              Recherche par nom
            </label>
            <input
              type="text"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Rechercher un club ou une commune…" // ← texte mis à jour
              className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2"
            />
          </div>

          <div className="w-full lg:w-64">
            <label className="text-xs uppercase tracking-wide opacity-70">
              Département
            </label>
            <select
              value={dep}
              onChange={(e) => setDep(e.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 bg-white"
            >
              <option value="">Tous</option>
              {departements.map((d) => (
                <option key={d} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>

          <div className="w-full lg:w-auto">
            <label className="text-xs uppercase tracking-wide opacity-70">
              Affichage
            </label>
            <div className="ml-2 mt-1 inline-flex rounded-lg ring-1 ring-slate-300 overflow-hidden">
              <button
                type="button"
                onClick={() => setMode("map")}
                className={`px-4 py-2 text-sm ${
                  mode === "map"
                    ? "bg-indigo-600 text-white"
                    : "bg-white hover:bg-slate-50"
                }`}
                title="Mode Carte"
              >
                Carte
              </button>
              <button
                type="button"
                onClick={() => setMode("list")}
                className={`px-4 py-2 text-sm ${
                  mode === "list"
                    ? "bg-indigo-600 text-white"
                    : "bg-white hover:bg-slate-50"
                }`}
                title="Mode Liste"
              >
                Liste
              </button>
            </div>
          </div>

          <div className="w-full lg:w-auto lg:ml-auto">
            <label className="text-xs uppercase tracking-wide opacity-70">
              {" "}
            </label>
            <div className="mt-1 flex gap-2">
              <div className="inline-flex items-center text-sm px-3 py-2 rounded-lg bg-slate-100">
                {loading
                  ? "Chargement…"
                  : `${filtered.length} club${filtered.length > 1 ? "s" : ""}`}
              </div>
              {(q || dep) && (
                <button
                  type="button"
                  onClick={() => {
                    setQ("");
                    setDep("");
                  }}
                  className="px-3 py-2 rounded-lg border border-slate-300 hover:bg-slate-50 text-sm"
                >
                  Réinitialiser
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="mt-4 w-full max-w-[1280px] mx-auto mb-8">
        {mode === "map" ? (
          <CarteClubsNouvelleAquitaine
            clubs={filtered}
            filterDepartement={dep}
            onDepartmentSelect={(code) => setDep(String(code))}
            // URL de ton GeoJSON (public/)
            geoJsonUrl="/departements-nouvelle-aquitaine.geojson"
          />
        ) : (
          <ClubListNA clubs={filtered} />
        )}
      </div>
    </div>
  );
};

export default PageCarteClubs;
